import { rem } from 'polished'
import { HorizontalMarginProps, VerticalMarginProps } from 'theme/css'

import Text from '../Text'
import { Props as TextProps } from '../Text/Text'
import { styled } from '../theme'
import { font } from '../theme/font'
import { media } from '../theme/media'

export const QuestionWrapper = styled(Text).attrs({})<
  TextProps & HorizontalMarginProps & VerticalMarginProps
>`
  display: inline-flex;
  flex-flow: column;
  align-content: flex-end;
  justify-content: flex-end;
  width: 100%;
  max-height: ${rem(60)};
  ${media.onlyMobile` ${font.s()}`}
  ${media.tablet` ${font.m()}`}
`
